/**
 * Scroll-lock safety net.
 *
 * Guarantees the body scroll lock can never stay stuck. iOS Safari is the main
 * offender: after a bfcache restore (back/forward), an interrupted close
 * animation, or app-driven (Rebuy/LSG) navigation, an overlay can leave the
 * document locked. A locked body renders the page behind the status/address
 * bars and kills the scroll bounce ("site tronqué en haut/en bas").
 *
 * On the events where this surfaces, if NO overlay is actually open we
 * force-clear every lock mechanism used in the theme. The `anyOverlayOpen`
 * guard prevents us from ever unlocking while a legitimate overlay is visible.
 *
 * Plain (non-module) IIFE so it runs everywhere with a simple `defer` tag.
 */
(function () {
  function anyOverlayOpen() {
    // Native <dialog> overlays: cart drawer, search modal, quick-add, menus.
    if (document.querySelector('dialog[open]')) return true;

    // <details scroll-lock open> (header drawer mega-menu).
    if (document.querySelector('details[scroll-lock][open]')) return true;

    // Rebuy SmartCart flyout.
    var rebuy = document.querySelector('.rebuy-cart__flyout');
    if (
      rebuy &&
      (rebuy.classList.contains('active') ||
        rebuy.classList.contains('is-active') ||
        rebuy.getAttribute('aria-hidden') === 'false')
    ) {
      return true;
    }

    // LSG slide cart.
    if (document.querySelector('#slidecart-wrapper.active')) return true;

    return false;
  }

  function isLocked() {
    return (
      document.body.style.position === 'fixed' ||
      document.documentElement.hasAttribute('scroll-lock') ||
      document.documentElement.hasAttribute('body-scroll-locked') ||
      document.documentElement.style.overflow === 'hidden' ||
      document.body.style.overflow === 'hidden'
    );
  }

  function clearAllLocks() {
    // Shared ref-counted lock from dialog.js (handles scroll restoration).
    if (window.ScrollLock && typeof window.ScrollLock.reset === 'function') {
      window.ScrollLock.reset();
    } else {
      document.body.style.width = '';
      document.body.style.position = '';
      document.body.style.top = '';
    }

    // Attribute-based locks (dialog.js <details> lock).
    document.documentElement.removeAttribute('scroll-lock');
    document.documentElement.removeAttribute('body-scroll-locked');
    document.documentElement.removeAttribute('keep-scrollbar');
    document.documentElement.style.removeProperty('--scroll-lock-gutter');

    // jQuery overflow lock from lsg-cart.js.
    if (document.documentElement.style.overflow === 'hidden') {
      document.documentElement.style.overflow = '';
    }
    if (document.body.style.overflow === 'hidden') {
      document.body.style.overflow = '';
    }
  }

  function reconcile() {
    if (isLocked() && !anyOverlayOpen()) clearAllLocks();
  }

  // bfcache restore (Safari back/forward) is the #1 source of a stuck lock.
  window.addEventListener('pageshow', reconcile);
  // History-driven overlay close (cart drawer uses pushState/back).
  window.addEventListener('popstate', reconcile);
})();
